import React from 'react'
import { graphql } from 'gatsby'
import { Container, Intro, Title, Section } from '../../components/page'
import { Buttons, LinkButton } from '../../components/button'
import { Accordion } from '../../components/accordion'
import { ContentfulRichText } from '../../components/contentful-rich-text'

import * as styles from './questions.module.scss'

export type QuestionsProps = Queries.QuestionsFragment

export const Questions = ({ title, text, items, buttons }: QuestionsProps) => {
  return (
    <Section className={styles.section} variant="lightblue">
      <Container>
        <Title center>{title}</Title>
        <Intro center className={styles.intro}>
          {text?.text}
        </Intro>
        <Accordion className={styles.questions}>
          {items?.map((faq) => (
            <Accordion.Item key={faq?.id} index={faq?.id!}>
              <Accordion.Button>{faq?.question}</Accordion.Button>
              <Accordion.Content>
                <ContentfulRichText text={faq?.text} />
              </Accordion.Content>
            </Accordion.Item>
          ))}
        </Accordion>
        <Buttons className={styles.buttons} center>
          {buttons?.map((item, index) => (
            <LinkButton
              key={item?.id}
              link={item}
              color={index === 0 ? 'primary' : 'secondary'}
              variant={index === 0 ? 'border' : null}
              size="lg"
            >
              {item?.title}
            </LinkButton>
          ))}
        </Buttons>
      </Container>
    </Section>
  )
}

export const QuestionsFragments = graphql`
  fragment Questions on ContentfulQuestions {
    __typename
    id
    title
    text {
      text
    }
    items {
      ...Faq
    }
    buttons {
      ...Link
    }
  }
`
